﻿import { ParameterGroupSettings } from "../../Model/ParameterGroupSettings";
import { RESTError } from "../RESTError";

var BASE_URL = '/api/ParameterGroupSettings';

export function getAllParamterGroupSettings(callback: (RESTError: RESTError, data?: any) => any): void {
    $.ajax(BASE_URL + '/Get/All', {
        cache: false,
        type: 'GET',
        timeout: 30000,
        success: (data: any, text: string, jqXHR: JQueryXHR) => {
            callback(null, data);
        },
        error: (jqXHR: JQueryXHR, textStatus: string, errorThrown: string) => {
            callback(new RESTError(jqXHR));
        }
    });
}

export function setParamterGroupSettings(req: ParameterGroupSettings, callback: (RESTError: RESTError) => any): void {
    $.ajax(BASE_URL + '/Set', {
        cache: false,
        type: 'POST',
        data: req,
        timeout: 30000,
        success: (data: any, text: string, jqXHR: JQueryXHR) => {
            callback(null);
        },
        error: (jqXHR: JQueryXHR, textStatus: string, errorThrown: string) => {
            callback(new RESTError(jqXHR));
        }
    });
}

export function deleteParamterGroupSettings(stationId: string, sensorId: string, parameterGroupId: string, callback: (RESTError: RESTError) => any): void {
    $.ajax(BASE_URL + '/Delete', {
        cache: false,
        type: 'POST',
        data: {
            "StationId": stationId,
            "Sensor": sensorId,
            "ParameterGroup": parameterGroupId
        },
        timeout: 30000,
        success: (data: any, text: string, jqXHR: JQueryXHR) => {
            callback(null);
        },
        error: (jqXHR: JQueryXHR, textStatus: string, errorThrown: string) => {
            callback(new RESTError(jqXHR));
        }
    });
}